import { motion } from "framer-motion";
import { Phone, MessageCircle, Instagram } from "lucide-react";
import { PHONE_TEL, WHATSAPP, INSTAGRAM_URL } from "@/data/site";

const ITEMS = [
  { id: "instagram", href: INSTAGRAM_URL, label: "Instagram'da İncele", icon: Instagram, cls: "dock-instagram", external: true },
  { id: "whatsapp", href: WHATSAPP, label: "WhatsApp'tan Ulaş", icon: MessageCircle, cls: "dock-whatsapp pulse-ring", external: true },
  { id: "call", href: PHONE_TEL, label: "Hemen Ara", icon: Phone, cls: "dock-phone", external: false },
];

export const FloatingButtons = () => (
  <div className="fixed z-[60] right-4 sm:right-6 bottom-5 sm:bottom-8 flex flex-col items-end gap-3" data-testid="floating-dock">
    {ITEMS.map((it, i) => {
      const Icon = it.icon;
      return (
        <motion.a
          key={it.id}
          href={it.href}
          target={it.external ? "_blank" : undefined}
          rel={it.external ? "noopener noreferrer" : undefined}
          aria-label={it.label}
          data-testid={`floating-${it.id}-button`}
          initial={{ opacity: 0, x: 40, scale: 0.6 }}
          animate={{ opacity: 1, x: 0, scale: 1 }}
          transition={{ delay: 2.6 + i * 0.12, type: "spring", stiffness: 220, damping: 18 }}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.94 }}
          className="group relative flex items-center"
        >
          <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-full bg-[#1a1118]/90 text-white text-xs font-medium px-3 py-1.5 opacity-0 translate-x-2 transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:translate-x-0 hidden sm:block">
            {it.label}
          </span>
          <span className={`${it.cls} relative w-14 h-14 rounded-full flex items-center justify-center text-white shadow-[0_15px_40px_-10px_rgba(139,0,79,0.55)]`}>
            <Icon size={24} className={it.id === "call" ? "phone-ring" : ""} />
          </span>
        </motion.a>
      );
    })}
  </div>
);
